<template>
  <div>
    <template
      v-if="hasResults">
      <div>
        <pigment-result
          v-for="hit in results.hits"
          :key="hit.id"
          :pigment="hit"
          :for-industry="forIndustry" />
      </div>

      <div class="my4 flex flex-column items-center">
        <div>
          <button
            v-if="canLoadMore"
            class="ce-btn ce-btn-light"
            :disabled="isLoading"
            @click.prevent="loadMore">
            <template v-if="isLoading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('productSearch.products.loadMoreCta') }}
            </template>
          </button>
        </div>

        <div
          v-if="hasResults"
          class="mt2 ms-2 center">
          <template v-if="canLoadMore">
            {{ $t('generic.resultsHint', { loaded: results.hits.length, total: resultsTotal }) }}
          </template>
          <template v-else>
            {{ $t('generic.resultsHintAllLoaded', { total: resultsTotal }) }}
          </template>
        </div>
      </div>
    </template>
    <div
      v-else
      class="center">
      <p class="ms2 bold">
        {{ $t('productSearch.products.noResults') }}
      </p>

      <div
        class="mt2"
        v-if="hasActiveFilters">
        <button
          class="ce-btn ce-btn-light"
          @click.prevent="$store.dispatch('resetFilters')">
          {{ $t('productSearch.products.resetFiltersCta') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import PigmentResult from 'components/product-search/PigmentResult.vue';

export default {
  components: { PigmentResult },
  computed: {
    ...mapState(['isLoading']),
    ...mapGetters(['hasResults', 'results', 'activeIndustries', 'hasActiveFilters', 'canLoadMore', 'resultsTotal']),
    forIndustry() {
      if (this.activeIndustries
        && Array.isArray(this.activeIndustries)
        && this.activeIndustries.length === 1) {
        return this.activeIndustries[0];
      }

      return null;
    }
  },
  methods: {
    ...mapActions(['loadMore'])
  }
};
</script>
